export const StarBoldSmallOutlineBanner = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="26" viewBox="0 0 28 26" width="28">
    <path
      d="m25.9935 9.04376-7.2813-1.025-3.2915-6.49165c-.5486-1.122615-2.2442-1.171424-2.8427 0l-3.24166 6.49165-7.33114 1.025c-1.296669.19523-1.795386 1.75714-.84782 2.68454l5.23653 5.0273-1.24679 7.0774c-.19949 1.269 1.19692 2.2452 2.34397 1.6595l6.53321-3.3678 6.4833 3.3678c1.1471.5857 2.5435-.3905 2.344-1.6595l-1.2468-7.0774 5.2365-5.0273c.9476-.9274.4489-2.48931-.8478-2.68454zm-6.982 6.88214 1.1969 6.7357-6.1841-3.1726-6.23398 3.1726 1.19692-6.7357-5.03705-4.7833 6.93221-.9762 3.1419-6.15001 3.092 6.15001 6.9322.9762z"
      fill="#292b29"
    />
  </svg>
);
